// @flow
import styled from 'styled-components';
import { media } from '~/core/utils/style';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: ${props => (props.menuAbove ? 'column' : 'row')};
`;

export const SpinnerContainerContainer = styled.div`width: 100%;`;

export const SpinnerContainer = styled.div`
    display: block;
    position: relative;
    width: 65%;
    margin: 0 auto;

    ${media.tablet`
      width: 50%;
      `} &:focus {
        outline: none;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/dual-color-range/base/styles.js